import { render, staticRenderFns } from "./SelectedCompetence.vue?vue&type=template&id=3ace0d34"
import script from "./SelectedCompetence.vue?vue&type=script&lang=js"
export * from "./SelectedCompetence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports